// Express / Unloading flags rendered as pills, shown beside the PO number(s) in both the last-mile
// (ShipmentListDrawer) and first-mile (FirstMileDrilldownDrawer) drill-down tables. Renders nothing
// when neither flag is set.
import { Tag } from "antd";
import React from "react";

interface Props {
  express?: boolean;
  unloading?: boolean;
}

const FlagPills: React.FC<Props> = ({ express, unloading }) =>
  express || unloading ? (
    <div style={{ display: "flex", gap: 4, flexWrap: "wrap" }}>
      {express && (
        <Tag color="blue" style={{ margin: 0 }}>
          Express
        </Tag>
      )}
      {unloading && (
        <Tag color="purple" style={{ margin: 0 }}>
          Unloading
        </Tag>
      )}
    </div>
  ) : null;

export default FlagPills;
